// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"1609573a","170":"cac56b42","909":"a407cbd4","931":"faf04c0f"}[chunkId] + ".chunk.js";
};